import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'

// Third Party Components
import * as VueGoogleMaps from 'vue2-google-maps'
import {Carousel, Slide} from 'vue-carousel'
import VueScrollTo from 'vue-scrollto'

// Project Components
import MainNavigation from "@/components/navigation/MainNavigation"
import ModalTrigger from "@/components/modals/ModalTrigger"
import ModalWindow from "@/components/modals/ModalWindow"
import LocationMap from "@/components/map/LocationMap"
import LocationTrigger from "@/components/map/LocationTrigger"
import LocationAddress from "@/components/map/LocationAddress"
import CookieConsent from "@/components/cookie-consent/CookieConsent";
import AccordionItem from "@/components/accordion/AccordionItem";

import store from '@/store'

Vue.use(VueGoogleMaps, {
    load: {
        key: googleApiKey
    }
})

Vue.use(VueScrollTo)

new Vue({
    el: '#app',
    store,
    components: {
        Carousel,
        Slide,
        MainNavigation,
        ModalTrigger,
        ModalWindow,
        LocationMap,
        LocationTrigger,
        LocationAddress,
        CookieConsent,
        AccordionItem
    },
    mounted() {
        if (window.location.hash) {
            let location = window.location.hash.replace("s-","");
            this.$nextTick(() => {
                this.$scrollTo(location, {
                    duration:2000,
                    offset: -72,
                })
            })
        }
    }
})




